<template>
  <section class="report-ratio-year">
    <error-alert v-if="$store.getters.errorMessageWithReportRatioYear" />
    <template v-else>
      <sheet-year
        :stockSymbol="$store.getters.headlinesOfReportRatioYear.stockSymbol"
        :companyName="$store.getters.headlinesOfReportRatioYear.companyName"
        :headline="$store.getters.headlinesOfReportRatioYear.liquiditiesYear"
        :unitOfTime="'年'"
        :unitOfNumber="'％'"
        :fields="fieldsOfLiquiditiesYear"
        :items="$store.getters.layerOfLiquiditiesYear"
      />
      <sheet-year
        :stockSymbol="$store.getters.headlinesOfReportRatioYear.stockSymbol"
        :companyName="$store.getters.headlinesOfReportRatioYear.companyName"
        :headline="
          $store.getters.headlinesOfReportRatioYear.returnOnInvestmentsYear
        "
        :unitOfTime="'年'"
        :unitOfNumber="'％'"
        :fields="fieldsOfReturnOnInvestmentsYear"
        :items="$store.getters.itemsOfReturnOnInvestmentsYear"
      />
      <sheet-year
        :stockSymbol="$store.getters.headlinesOfReportRatioYear.stockSymbol"
        :companyName="$store.getters.headlinesOfReportRatioYear.companyName"
        :headline="$store.getters.headlinesOfReportRatioYear.perShareRatiosYear"
        :unitOfTime="'年'"
        :unitOfNumber="'元、％'"
        :fields="fieldsOfPerShareRatiosYear"
        :items="sortFieldsOfPerShareRatiosYear"
      />
      <sheet-year
        :stockSymbol="$store.getters.headlinesOfReportRatioYear.stockSymbol"
        :companyName="$store.getters.headlinesOfReportRatioYear.companyName"
        :headline="
          $store.getters.headlinesOfReportRatioYear.operatingPerformancesYear
        "
        :unitOfTime="'年'"
        :unitOfNumber="'天'"
        :fields="fieldsOfOperatingPerformancesYear"
        :items="$store.getters.itemsOfOperatingPerformancesYear"
      />
    </template>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import mixins from "@/utility/mixins.js";
import SheetYear from "@/components/SheetYear.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";

export default {
  name: "ReportRatioYear",
  mixins: [mixins],
  components: {
    SheetYear,
    ErrorAlert
  },
  created() {
    // this.$store.dispatch("FETCH_REPORT_RATIO_YEAR");
  },
  computed: {
    sortFieldsOfPerShareRatiosYear() {
      const baseData = this.$store.getters.itemsOfPerShareRatiosYear.filter(
        item => item.subTitle !== "每股盈餘－完全稀釋－EPS"
      );
      const itemEPS = this.$store.getters.itemsOfPerShareRatiosYear.find(
        item => item.subTitle === "每股盈餘－完全稀釋－EPS"
      );
      itemEPS.subTitle = "每股EPS";
      return [itemEPS, ...baseData];
      // return this.$store.getters.itemsOfPerShareRatiosYear;
    },
    ...mapGetters([
      "liquiditiesYear",
      "returnOnInvestmentsYear",
      "perShareRatiosYear",
      "operatingPerformancesYear"
    ]),
    fieldsOfLiquiditiesYear() {
      return this.fieldsOfYear(this.liquiditiesYear);
    },
    fieldsOfReturnOnInvestmentsYear() {
      return this.fieldsOfYear(this.returnOnInvestmentsYear);
    },
    fieldsOfPerShareRatiosYear() {
      return this.fieldsOfYear(this.perShareRatiosYear);
    },
    fieldsOfOperatingPerformancesYear() {
      return this.fieldsOfYear(this.operatingPerformancesYear);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep caption {
  padding-bottom: 0;
}
::v-deep .table-hover tbody tr:hover {
  background-color: #343a40;
  color: #fff;
}
</style>
